import React, { useMemo } from "react";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { webstoreCollection } from "../../../components/firebase/DataProvider";
import upperFirst from "lodash/upperFirst";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import List from "@material-ui/core/List";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconBeauty from "../../../assets/images/iconBeauty";
import useStyles from "./style/style";
import { DialogTitle, IconButton } from "@material-ui/core";

const LowerRank = ({ item, index }) => {
  const classes = useStyles();

  const [webstore] = useDocumentDataOnce(
    webstoreCollection.doc(item?.document_id ?? "unknown")
  );

  return (
    <>
      <ListItem key={index} button>
        <ListItemAvatar>
          <Avatar src={webstore?.logo ? webstore?.logo : IconBeauty}>
            <IconBeauty />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography className={classes.liquidListLeadrboard}>
              {`${item?.nama?.split(" ")?.[0]} ****`}
            </Typography>
          }
          secondary={
            <Typography className={classes.liquidListLeadrboard}>
              {upperFirst(item?.tipe_akun)}
            </Typography>
          }
        />
        <ListItemSecondaryAction>
          <Typography className={classes.liquidBoldLeadrboard}>
            #{index + 4}
          </Typography>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider light />
    </>
  );
};

function DialogLeaderboard({ open, handleClose, data, topTree }) {
  const classes = useStyles();
  const lowerRanks = useMemo(() => data.slice(3), [data]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Leaderboard</Typography>
        </div>
      </DialogTitle>{" "}
      <DialogContent dividers style={{ padding: 10 }}>
        <Grid spacing={1} container className={classes.wrapLeaderboard}>
          {topTree?.map((item) => (
            <Grid item xs={4} md={2} lg={2}>
              <div
                className={
                  item?.rank === 1 ? classes.wrapItem : classes.wrapItemLight
                }
              >
                <img src={item?.mahkota} alt="mahkota2" />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Avatar className={classes.medium}>
                    <IconBeauty />
                  </Avatar>
                </div>
                <Typography className={classes.liquidLeadrboard}>
                  {item?.nama?.split(" ")?.[0]} ****
                </Typography>
                <Typography className={classes.liquidLeadrboard}>
                  {upperFirst(data?.tipe_akun ?? "")}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
        {/* <Gap height={20} /> */}
        <List>
          {lowerRanks?.map((item, index) => {
            return <LowerRank item={item} index={index} />;
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default DialogLeaderboard;
